export default "__VITE_ASSET__C5$u0Wq4__"